module.exports = require("next/dist/compiled/node-html-parser");